import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _PropTypes from 'prop-types';
import * as React from 'react';
import { useId } from 'react-id-generator';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);

var TabsContext = function TabsContext(_ref) {
  var children = _ref.children,
      value = _ref.value;

  var _useId = useId(),
      _useId2 = _slicedToArray(_useId, 1),
      id = _useId2[0];

  var context = React.useMemo(function () {
    return {
      id: id,
      value: value
    };
  }, [id, value]);
  return /*#__PURE__*/jsx(Context.Provider, {
    value: context,
    children: children
  });
};

TabsContext.propTypes = {
  "children": _PropTypes.node,
  "value": _PropTypes.any
};
TabsContext.displayName = "TabsContext";
function getTabId(context, value) {
  return "".concat(context.id, "-T-").concat(value);
}
function getPanelId(context, value) {
  return "".concat(context.id, "-P-").concat(value);
}
function useTabContext() {
  var context = React.useContext(Context);
  if (!context) throw new TypeError("No TabContext provided");
  return context;
}

export { TabsContext, getPanelId, getTabId, useTabContext };
